/**
 * Feature Constants and Route Mappings
 * Centralized configuration for feature-based access control
 */

/**
 * Feature IDs
 */
export const FEATURE_MONITORS = 'monitors';
export const FEATURE_LOG_ANALYZER = 'log-analyzer';
export const FEATURE_TRIAGE = 'triage';
export const FEATURE_SCRAPER = 'scraper';

/**
 * All available features
 */
export const ALL_FEATURES = [
  FEATURE_MONITORS,
  FEATURE_LOG_ANALYZER,
  FEATURE_TRIAGE,
  FEATURE_SCRAPER,
] as const;

/**
 * Default features when organization has no features array
 */
export const DEFAULT_FEATURES = [
  FEATURE_MONITORS,
  FEATURE_TRIAGE,
] as const;

/**
 * Route to feature mapping
 * Maps application routes to their corresponding feature IDs
 */
export const ROUTE_TO_FEATURE_MAP: Record<string, string> = {
  '/monitors': FEATURE_MONITORS,
  '/log-analyzer': FEATURE_LOG_ANALYZER,
  '/triage': FEATURE_TRIAGE,
  // Scraper is a tab within monitors, not a separate route
};

/**
 * Feature to route mapping
 * Maps feature IDs to their primary routes
 */
export const FEATURE_TO_ROUTE_MAP: Record<string, string> = {
  [FEATURE_MONITORS]: '/monitors',
  [FEATURE_LOG_ANALYZER]: '/log-analyzer',
  [FEATURE_TRIAGE]: '/triage',
  // Scraper doesn't have a separate route, it's accessed via monitors tab
};

/**
 * Get feature ID for a given route path
 */
export function getFeatureForRoute(path: string): string | null {
  // Check exact match first
  if (ROUTE_TO_FEATURE_MAP[path]) {
    return ROUTE_TO_FEATURE_MAP[path];
  }
  
  // Check if path starts with a route (for nested routes like /monitors/123)
  for (const [route, feature] of Object.entries(ROUTE_TO_FEATURE_MAP)) {
    if (path.startsWith(route)) {
      return feature;
    }
  }
  
  return null;
}

/**
 * Get route for a given feature ID
 */
export function getRouteForFeature(featureId: string): string | null {
  return FEATURE_TO_ROUTE_MAP[featureId] || null;
}

